import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import { PageHeadingDTO } from '@lib/strapi/dtos/components/shared/pageHeading.dto';

/** The page-title band: full width tint, boxed heading, h1 per page. */
const PageHeadingImplementation = ({ section }: ComponentProps<PageHeadingDTO>) => {
  const title = (section as { title?: string } | undefined)?.title;
  if (!title) return null;
  return (
    <div className="bg-violet-050">
      <div className="shell py-9 md:py-12">
        <h1 className="text-3xl font-extrabold tracking-tight text-ink md:text-4xl">{title}</h1>
      </div>
    </div>
  );
};

export default PageHeadingImplementation;
